import { useEffect, useRef, useState } from "react";
import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";
import calculateSmartAssetMarkerPosition from "layouts/nms/utils/calculateSmartAssetMarkerPosition";
import FolderIcon from "@mui/icons-material/Folder";
import CircleIcon from "@mui/icons-material/Circle";
import { Card, Grid, IconButton } from "@mui/material";
import MDTypography from "components/MDTypography";
import { telemetry } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";
import loggerFactory from "globals/logger/logger-factory";


function AssetImage({
  isAdmin,
  isEditMode,
  assetImageName,
  bufferLeft,
  bufferTop,
  handleAssignSensorPopupOpen,
  handleParentRefCurrent,
  assetSensorListQuery,
  category,
  assetId,
  assetIpAddress,
}) {
  const [contextMenu, setContextMenu] = useState(null);
  const [contextMenuEvent, setContextMenuEvent] = useState(null);
  const [assetData, setAssetData] = useState([]);
  const [assetImage, setAssetImage] = useState("");
  const [assetImageHeight, setAssetImageHeight] = useState("");
  const [assetImageWidth, setAssetImageWidth] = useState("");
  const imageRef = useRef(null);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    const parent = document.getElementById("smartAssetParent");
    handleParentRefCurrent(parent);
  }, []);

  useEffect(() => {
    if (assetId) {
      telemetry
        .get(`/SCADAAsset/uuid/${assetId}`)
        .then((res) => {
          setAssetData(res.data.data);
          setAssetImageWidth(res.data.data.categoryData.width);
          setAssetImageHeight(res.data.data.categoryData.height);
          const imageName = res.data?.data?.categoryData?.imageName;
          const imagePath = `/images/${imageName}`;
          const img = new Image();
          img.onload = () => setAssetImage(imagePath); // Image exists
          img.onerror = () => setAssetImage(null); // Image doesn't exist
          img.src = imagePath;

          loggerFactory.info("  get asset data", res.data.data);
        })
        .catch((error) => {
          loggerFactory.debug("unable to get asset data", error);
          setNotify({
            isOpen: true,
            status:
              error.response.data.messageDetail +
              " " +
              error.response.data.message,
            type: "error",
            pagename: "Asset",
          });
        });
    } else {
      setNotify({
        isOpen: true,
        status: "Asset Id  is Null",
        type: "error",
        pagename: "Asset",
      });
    }
  }, [assetId]);

  const handleImageClick = (event) => {
    if (!imageRef.current) {
      return;
    }
    const imageDimentions = imageRef.current.getBoundingClientRect();

    const [top, left] = calculateSmartAssetMarkerPosition(
      event,
      imageDimentions,
      window.scrollY,
      bufferLeft,
      bufferTop
    );

    handleAssignSensorPopupOpen(left, top);

    setContextMenu(null);
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null
    );
    setContextMenuEvent(event);
  };

  const handleClick = () => {
    if (
      assetData &&
      assetData.categoryData &&
      assetData.categoryData.managementURL
    ) {
      let managementURL = assetData.categoryData.managementURL;
      managementURL = managementURL.replace("IPADDR", assetIpAddress);

      loggerFactory.info("open url :", managementURL);
      const popupFeatures = "fullscreen=yes,resizable=yes,scrollbars=yes";
      window.open(managementURL, "_blank", popupFeatures);
    } else {
      setNotify({
        isOpen: true,
        status: "Please Define Url In Category",
        type: "info",
        pagename: "Asset",
      });
    }
  };

  return (
    <MDBox onContextMenu={handleContextMenu} sx={{ cursor: "context-menu" }}>
      <div>{generateMarkerElements()}</div>
      {isAdmin && isEditMode && (
        <Menu
          open={contextMenu !== null}
          onClose={() => setContextMenu(null)}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          <MenuItem onClick={() => handleImageClick(contextMenuEvent)}>
            Assign sensor
          </MenuItem>
        </Menu>
      )}
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );

  function generateMarkerElements() {
    const data = assetSensorListQuery?.data;

    return data?.map((item, index) => {
      let color;
      switch (item.sensorStatus) {
        case 0:
          color = "green";
          break;
        case 1:
          color = "yellow";
          break;
        case 2:
          color = "red";
          break;
        default:
          color = "gray";
      }

      if (item.sensorCode == "ICMP") {
        return (
          <>
            {" "}
            <MDBox
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "60vh",
              }}
            >
              <IconButton onClick={handleClick}>
                {assetImage ? (
                  <img
                    src={assetImage}
                    alt="Smart Asset"
                    style={{
                      width: assetImageWidth ? `${assetImageWidth}px` : "100px",
                      height: assetImageHeight
                        ? `${assetImageHeight}px`
                        : "100px",
                    }}
                    ref={imageRef}
                  />
                ) : (
                  <FolderIcon
                    style={{
                      color: color,
                      height: "150px",
                      width: "150px",
                    }}
                  />
                )}
              </IconButton>
            </MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card
                  style={{
                    alignItems: "center",
                    padding: "15px",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 1.3)",
                  }}
                >
                  <MDTypography
                    style={{ cursor: "pointer" }}
                    onClick={handleClick}
                  >
                    {" "}
                    <div
                      style={{
                        position: "absolute",
                        marginTop: "8px",
                        left: "46%",
                        color: color,
                        fontSize: "24px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          transform: "translateZ(24px)",
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        <CircleIcon />
                      </div>
                    </div>
                    {item.sensorType}
                  </MDTypography>
                </Card>
              </Grid>
            </Grid>
          </>
        );
      }
    });
  }
}

export default AssetImage;
